export default {
  fotobooks: 'Печать фотокниги онлайн - фотокнига с доставкой - Фотопочта',
  calendars: 'Календари с фото онлайн - заказать календарь с доставкой - Фотопочта',
  photo: 'Печать фото онлайн - напечатать фотографии с доставкой - Фотопочта',
  aboutUS: 'Фотопочта - сервис печати фотографий и фотопродукции онлайн',
};
